/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { UserContactsState, UserContactsTypes } from './types';

const INITIAL_STATE: UserContactsState = {
  user_contacts: [],
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<UserContactsState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case UserContactsTypes.GET_USER_CONTACTS_REQUEST:
        draft.request = { ...INITIAL_STATE.request, loading: true };
        break;

      case UserContactsTypes.GET_USER_CONTACTS_SUCCESS:
        if (!result) return;

        draft.user_contacts = result.data.contacts?.map((contact: any) => {
          return {
            acesso_servico_online: contact.acesso_servico_online,
            ativo: contact.ativo,
            cargo_id: contact.cargo_id,
            cliente_id: contact.cliente_id,
            email: contact.email,
            id: contact.id,
            nome: contact.nome,
          };
        });
        draft.request = { ...INITIAL_STATE.request, loaded: true };
        break;

      case UserContactsTypes.GET_USER_CONTACTS_FAILURE:
        draft.request = { ...INITIAL_STATE.request, error: true };
        break;

      default:
    }
  });
};

export default reducer;
